import React, { useState } from "react";
import { api } from "../../lib/api";
import QuickForm, { BTN, IN, errMsg } from "./QuickForm";

const today = () => new Date().toISOString().slice(0, 10);

// Corrective action row: complete with evidence (responsible) and verify / reject (a different person).
export function CaRow({ ca, onDone }) {
  const [note, setNote] = useState("");
  const [err, setErr] = useState("");
  const act = (path, body) => api.post(`/hse/corrective-actions/${ca.id}/${path}`, body).then(() => { setNote(""); setErr(""); onDone(); }).catch((e) => setErr(errMsg(e)));
  return (
    <li className="border border-erf-borderCream rounded bg-white p-3 space-y-2 text-sm" data-testid={`hse-ca-${ca.id}`}>
      <p><span className="font-semibold">{ca.description}</span> · {ca.responsible_name} · due {ca.due_date} · <span data-testid={`hse-ca-state-${ca.id}`}>{ca.state}</span>
        {ca.overdue && <span className="ml-1 text-red-800 font-semibold" data-testid={`hse-ca-overdue-${ca.id}`}>Overdue</span>}</p>
      {ca.state !== "verified" && <input className={IN} placeholder={ca.state === "open" ? "Evidence: what was done" : "Verification note"} value={note} onChange={(e) => setNote(e.target.value)} data-testid={`hse-ca-note-${ca.id}`} />}
      <div className="flex flex-wrap gap-2">
        {ca.state === "open" && <button type="button" className={BTN} onClick={() => act("complete", { evidence_note: note })} data-testid={`hse-ca-complete-${ca.id}`}>Mark done with evidence</button>}
        {ca.state === "done" && <><button type="button" className={`${BTN} bg-erf-dark text-white`} onClick={() => act("verify", { decision: "verified", note })} data-testid={`hse-ca-verify-${ca.id}`}>Verify</button>
          <button type="button" className={BTN} onClick={() => act("verify", { decision: "rejected", note })} data-testid={`hse-ca-reject-${ca.id}`}>Not done yet</button></>}
      </div>
      {err && <p role="alert" className="text-red-700" data-testid={`hse-ca-error-${ca.id}`}>{err}</p>}
    </li>
  );
}

export function NewCa({ source, team, onDone }) {
  return (
    <QuickForm id={`hse-newca-${source.id}`} submitLabel="Add corrective action" initial={{ description: "", responsible_id: team[0]?.id || "", due_date: today() }}
      fields={[{ key: "description", label: "Action", wide: true }, { key: "responsible_id", label: "Responsible", type: "select", options: team.map((u) => ({ value: u.id, label: u.name })) },
        { key: "due_date", label: "Due", type: "date" }]}
      onSubmit={(v) => api.post("/hse/corrective-actions", { ...v, source_kind: source.kind, source_id: source.id }).then(onDone)} />
  );
}

// Incident close: review note; serious ones only by the Founder/Administrator (server enforced, message shown).
export function IncidentRow({ inc, onDone }) {
  const [note, setNote] = useState("");
  const [err, setErr] = useState("");
  const close = () => api.post(`/hse/incidents/${inc.id}/close`, { review_note: note }).then(onDone).catch((e) => setErr(errMsg(e)));
  return (
    <li className="border border-erf-borderCream rounded bg-white p-3 space-y-2 text-sm" data-testid={`hse-incident-${inc.id}`}>
      <p><span className="font-semibold">{inc.kind === "near_miss" ? "Near miss" : "Incident"}</span> · {inc.severity} · {inc.occurred_on} · {inc.state}
        {inc.osha_recordable !== null && inc.osha_recordable !== undefined && <> · OSHA recordable (your entry): {inc.osha_recordable ? "yes" : "no"}</>}</p>
      <p className="break-words">{inc.description}</p>
      {inc.state === "open" && <><input className={IN} placeholder="Review note" value={note} onChange={(e) => setNote(e.target.value)} data-testid={`hse-incident-note-${inc.id}`} />
        <button type="button" className={BTN} onClick={close} data-testid={`hse-incident-close-${inc.id}`}>Close after review</button></>}
      {inc.review_note && <p className="text-xs">Review: {inc.review_note}</p>}
      {err && <p role="alert" className="text-red-700" data-testid={`hse-incident-error-${inc.id}`}>{err}</p>}
    </li>
  );
}
